import React from 'react';
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import LoadingOverlay from './components/LoadingOverlay';

import Home from './pages/Home';
import Translate from './pages/Translate';
import Convert from './pages/Convert';

import Return from './pages/Return';
import Error_404 from './pages/Error_404';

// Router
const router = createBrowserRouter([
  {
    path: "/",
    element: <Home/>,
    errorElement: <Error_404/>
  },
  {
    path: "translate",
    element: <Translate />,
    errorElement: <Error_404/>
  },
  {
    path: "convert",
    element: <Convert />,
    errorElement: <Error_404/>
  },
  {
    path: "return",
    element: <Return />,
    errorElement: <Error_404/>
  },
]);


function App() {
  return (
    <>
      <RouterProvider router={router} />
      <LoadingOverlay/>
    </>
  )
}

export default React.memo(App)
